import { Box, Loader } from '@mantine/core';

/**
 * Full-page centered loader used as the Suspense fallback
 * while lazy-loaded route chunks are being fetched.
 */
export function PageLoader() {
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#0a0a0b',
      }}
    >
      <Loader color="orange" size="lg" />
    </Box>
  );
}
